import React, { Fragment, useState } from 'react'

export function RemoveItem({
  onClick,
  remove,
  cannotRemove,
  cannotRemoveText,
  alternateStyles = null
}) {
  let className = 'mt-24 md:mt-16 mb-0 text-link text-16 lg:text-18'
  const [isLoading, setIsLoading] = useState(false)

  if (!remove) {
    return null
  }

  if (alternateStyles) {
    className = alternateStyles
  }

  const onRemoveClick = async event => {
    event.preventDefault()

    setIsLoading(true)

    await onClick()

    if (setIsLoading.done) {
      setIsLoading(false)
    }
  }

  return (
    <Fragment>
      <button
        aria-busy={isLoading}
        aria-describedby={cannotRemove ? 'remove-warn' : null}
        className={className}
        disabled={isLoading || cannotRemove}
        onClick={onRemoveClick}
        type="button"
      >
        {isLoading ? (
          <span>
            Removing item <span aria-hidden="true">...</span>
          </span>
        ) : (
          'Remove'
        )}
      </button>

      {/*
        Had to add this text twice since sr-only can't
        be removed responsively
      */}
      {cannotRemove && (
        <span
          id="remove-warn"
          className="sr-only"
        >
          {cannotRemoveText}
        </span>
      )}
    </Fragment>
  )
}

export default RemoveItem
